// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"styles_dropzone__2Dsoo"};